import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'

export const Title = ({ title }) => {
  return (
    <Translate
      value={'userManagement.orderManagement.orderDetail.' + title}
      className="fw600"
    />
  )
}

Title.propTypes = {
  title: PropTypes.string,
}

Title.defaultProps = {
  title: '',
}
